'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    id: 'faq-1',
    q: 'How long does it take to receive my export?',
    a: 'Most requests are processed within 2–4 hours during business hours. Complex posts with 10,000+ comments may take up to 24 hours.',
  },
  {
    id: 'faq-2',
    q: 'What Instagram post types are supported?',
    a: 'We support all public Instagram Reels and Posts. Private accounts cannot be extracted. Stories and highlights are not currently supported.',
  },
  {
    id: 'faq-3',
    q: 'In what formats will I receive the file?',
    a: 'By default, exports are delivered as CSV. You can request Excel (XLSX), ZIP, JSON, or TXT in the notes field when submitting.',
  },
  {
    id: 'faq-4',
    q: 'How will I receive my file?',
    a: 'Once completed, your file is available to download directly from your dashboard. We also send it to your WhatsApp number and email address.',
  },
  {
    id: 'faq-5',
    q: 'Can I submit multiple requests at once?',
    a: 'Yes. You can submit as many requests as you need. Each request is tracked separately in your dashboard with its own status and download.',
  },
];

export default function LandingFAQ() {
  const [open, setOpen] = useState<string | null>('faq-1');

  return (
    <section id="faq" className="py-24 px-6 bg-background">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-black uppercase tracking-widest text-primary mb-3">FAQ</p>
          <h2 className="text-3xl font-black text-foreground tracking-tight">Common Questions</h2>
        </div>

        <div className="space-y-3">
          {faqs?.map((faq) => (
            <div key={faq?.id} className="bg-card border-2 border-border rounded-lg overflow-hidden hover:border-primary/30 transition-colors">
              <button
                onClick={() => setOpen(open === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-muted/50 transition-colors"
              >
                <span className="text-sm font-bold text-foreground pr-4">{faq?.q}</span>
                <ChevronDown
                  size={16}
                  className={['text-primary flex-shrink-0 transition-transform duration-200', open === faq?.id ? 'rotate-180' : '']?.join(' ')}
                />
              </button>
              {open === faq?.id && (
                <div className="px-5 pb-4 fade-in">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}